import * as React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

type NavEnrollCtaContextType = {
  slot: HTMLElement | null;
  setSlot: (element: HTMLElement | null) => void;
};

const NavEnrollCtaContext = createContext<NavEnrollCtaContextType>({
  slot: null,
  setSlot: () => undefined,
});

export const useNavEnrollCtaSlot = () => {
  return useContext(NavEnrollCtaContext);
};

/**
 * Bridges the page header and the page body: the header renders an empty slot element and publishes
 * it here, letting a module deep in the page portal its CTA into the nav without prop drilling.
 */
const NavEnrollCtaProvider = ({ children }: React.PropsWithChildren) => {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  const value = useMemo(() => ({ slot, setSlot }), [slot]);

  return <NavEnrollCtaContext.Provider value={value}>{children}</NavEnrollCtaContext.Provider>;
};

export default NavEnrollCtaProvider;
